module.exports = __webpack_public_path__ + "img/10.64aad57b.png";